import React, { Suspense } from "react";
import "../Registration/Registration.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
} from "react-router-dom";
import { Button, Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { BsFacebook } from "react-icons/bs";
import Loading from "../../components/Loading";
import Header from "../../DefaultLayout/Header";
import Footer from "../../DefaultLayout/Footer";
import NavbarSection from "../../DefaultLayout/Navbar";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar";

const Non_registered_user = () => {
  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <Header />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="container mb-5 pt-5">
        <div className="row">
          <div className="register-non-user">
            <div className="otp-box-rg-new-non">
              <div className="img-mob-usr text-center">
                <h2>
                  <strong>Register for Non registered user</strong>
                </h2>
                <FormGroup className="set-bg-feild">
                  <Input
                    type="text"
                    name="userName"
                    placeholder="Lorem ipsumgfg"
                  />
                </FormGroup>
                <FormGroup className="set-bg-feild">
                  <Input
                    type="password"
                    name="Password"
                    placeholder="Lorem ipsum"
                  />
                </FormGroup>
                <FormGroup className="set-bg-feild">
                  <Input
                    type="text"
                    name="Password"
                    placeholder="Lorem ipsum dolor564"
                  />
                </FormGroup>
                <FormGroup className="set-bg-feild">
                  <Input
                    type="text"
                    name="Password"
                    placeholder="Lorem ipsum dolor sit"
                  />
                </FormGroup>
                <div className="col-lg-12 col-md-12">
                  <div className="register-btn pt-3">
                    <button>Register</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};

export default Non_registered_user;
